import BigNumber from 'bignumber.js';
import { Address, PublicClient } from 'viem';

import { getLiquidStakingTokenContract } from 'modules/api/contracts/getLiquidStakingTokenContract';
import { convertFromWei } from 'modules/api/utils';

export async function getStakeTokenRatio(
  client: PublicClient,
  poolAddress?: Address,
): Promise<BigNumber> {
  const contract = getLiquidStakingTokenContract(client, poolAddress);

  const ratioWei: bigint = await contract.read.getExchangeRate();

  return convertFromWei(ratioWei);
}
